import { CHATROOM_MESSAGE_FILES_VISIBLE_COUNT } from '../Chatroom.constants'

export function getChatroomMessageFilesVisible({ files, isExpanded }) {
  return isExpanded
    ? files
    : files.slice(0, CHATROOM_MESSAGE_FILES_VISIBLE_COUNT)
}
